import React from 'react';
import {useToggleLanguage} from "../../hooks/useToggleLanguage";
import {useTranslation} from "react-i18next";

/**
 * Button to toggle between languages (e.g., 'en' and 'pl').
 * @author Ryszard Trojnacki
 */
export const ToggleLanguageButton = () => {
    const toggleLanguage=useToggleLanguage();
    const { i18n } = useTranslation();
    return <button
        onClick={toggleLanguage}
        className={`flex items-center text-gray-400 hover:text-white transition-colors`}
    >
        <span className="mr-1">🌐</span>
        {i18n.language === 'en' ? "PL" : "EN"}
    </button>
}